import { ActivityTracker } from '@/services/activityTracker/adapters/contracts/activity-tracker';
import amplitude from 'amplitude-js';

export class AmplitudeTracker implements ActivityTracker {
  protected amplitude: amplitude.AmplitudeClient;

  protected identifyObject: amplitude.Identify;

  constructor(apiKey: string) {
    amplitude.getInstance().init(apiKey);
    this.amplitude = amplitude.getInstance();
    this.identifyObject = new amplitude.Identify;
  }

  identifyUser = (): void => {
    this.amplitude.identify(this.identifyObject);
  };

  setUser = (id: string | null): void => {
    this.amplitude.setUserId(id);
  };

  trackEvent = (event: string, properties: Record<string, unknown>): void => {
    this.amplitude.identify(this.identifyObject);
    this.amplitude.logEvent(event, properties);
  };

  unsetUser = (): void => {
    this.amplitude.setUserId(null);
    this.amplitude.regenerateDeviceId();
  };
}
